export class Status {

  public loading: boolean;
  public load: boolean;
  public error: boolean;
  public empty: boolean;

  constructor() {
    this.loading = false;
    this.load = false;
    this.error = false;
    this.empty = false;
  }

  setLoading() {
    this.loading = true;
    this.error = this.load = this.empty = false;
  }

  setError() {
    this.error = true;
    this.loading = this.load = this.empty = false;
  }

  setLoad() {
    this.load = true;
    this.loading = this.error = this.empty = false;
  }

  setEmpty() {
    this.empty = true;
    this.loading = this.error = this.load = false;
  }

}